import React from "react";
import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { useSignup } from "../SignupProvider";
import { ASSETS } from "../../data/site";

export const BetaCTA = () => {
  const { openSignup } = useSignup();

  return (
    <section className="relative px-6 py-12 md:px-12" data-testid="beta-cta-section">
      <div className="relative mx-auto max-w-7xl overflow-hidden rounded-[2.5rem] bg-[#2F5E43] px-8 py-20 text-center md:px-16 md:py-28">
        <div
          className="pointer-events-none absolute -right-20 -top-20 h-80 w-80 rounded-full opacity-30 blur-3xl"
          style={{ background: "radial-gradient(circle, #8AA583 0%, transparent 70%)" }}
        />
        <div
          className="pointer-events-none absolute -bottom-24 -left-16 h-80 w-80 rounded-full opacity-20 blur-3xl"
          style={{ background: "radial-gradient(circle, #FBFBF9 0%, transparent 70%)" }}
        />
        <div className="relative">
          <Reveal>
            <div className="mx-auto mb-2 flex h-16 w-16 items-center justify-center rounded-2xl bg-white/95 shadow-lg">
              <img src={ASSETS.logoIcon} alt="SisterSafe" className="h-11 w-11 object-contain" />
            </div>
          </Reveal>
          <Reveal delay={0.08}>
            <h2 className="font-heading mx-auto mt-5 max-w-3xl text-4xl font-semibold leading-[1.1] tracking-tight text-white md:text-6xl">
              Help Shape the Future of Women's Safety
            </h2>
          </Reveal>
          <Reveal delay={0.16}>
            <p className="mx-auto mt-6 max-w-xl text-lg leading-relaxed text-white/80">
              Help shape a safer future for women. Your feedback helps us build the
              safety network women deserve.
            </p>
          </Reveal>
          <Reveal delay={0.24}>
            <div className="mt-10 flex flex-col justify-center gap-3 sm:flex-row">
              <button
                onClick={() => openSignup("waitlist")}
                className="group inline-flex items-center justify-center gap-2 rounded-full bg-white px-8 py-4 font-medium text-[#2F5E43] transition-colors hover:bg-[#F2F5F2]"
                data-testid="cta-waitlist-btn"
              >
                Join the Waitlist
                <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
              </button>
              <button
                onClick={() => openSignup("beta")}
                className="inline-flex items-center justify-center rounded-full border border-white/40 px-8 py-4 font-medium text-white transition-colors hover:bg-white/10"
                data-testid="cta-beta-btn"
              >
                Become a Beta Tester
              </button>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
